import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { SectionHeader } from '@/components/cccd/SectionHeader';
import { LoadState } from '@/components/ui/LoadState';
import { cccdAdmin, MAX_ACTIVE_SPONSORS } from '@/lib/api/cccdAdminClient';

// Acceso a los patrocinadores del evento (nacional o regional): resumen de cuántos
// se publican en las pantallas de puntos y enlace a la página de administración
// (puntos-sponsors-and-live-cache). Cada evento tiene los suyos.
export function EventSponsorsSection({ parent }: { parent: { type: 'event' | 'regional'; id: string } }) {
  const base = parent.type === 'regional' ? `/cccd/regionals/${parent.id}` : `/cccd/events/${parent.id}`;
  const { data: sponsors = [], isLoading } = useQuery({
    queryKey: ['event-sponsors', parent.id],
    queryFn: () => cccdAdmin.listSponsors(parent.id),
  });

  const active = sponsors.filter((s) => s.isActive).length;
  const published = sponsors.filter((s) => s.isActive && s.logoUrl).length;
  const missingLogo = sponsors.filter((s) => s.isActive && !s.logoUrl).length;

  return (
    <SectionHeader
      title="Patrocinadores"
      subtitle="Sus logos se muestran en las pantallas públicas de resultados y lanzamientos de este evento"
      icon={
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none">
          <path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      }
    >
      {isLoading ? (
        <LoadState />
      ) : (
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            <p>
              <strong className="text-gray-800 dark:text-white/90">{published}</strong> publicados en pantalla · {active} de {MAX_ACTIVE_SPONSORS} activos
            </p>
            {missingLogo > 0 && (
              <p className="mt-1 text-warning-600 dark:text-warning-400">
                {missingLogo} {missingLogo === 1 ? 'patrocinador activo no tiene' : 'patrocinadores activos no tienen'} logo y no se muestra
                {missingLogo === 1 ? '' : 'n'}.
              </p>
            )}
          </div>
          <Link
            to={`${base}/sponsors`}
            className="min-h-11 rounded-[10px] border border-gray-300 px-4 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
          >
            Administrar patrocinadores
          </Link>
        </div>
      )}
    </SectionHeader>
  );
}
